import {
  Component,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ClickedElementService } from './shared/services/clickedElement.service';
import { setSomethingWentWrongModalAppComponent } from './store/actions/core.actions';
import { getSomethingWentWrongModalOpen } from './store/selectors/core.selectors';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnDestroy {
  public somethingWentWrongModalOpen$ = this.store.select(getSomethingWentWrongModalOpen);

  constructor(
    private clickedElementService: ClickedElementService,
    private store: Store,
  ) {}

  public ngOnDestroy(): void {
    this.clickedElementService.documentClickedTarget.complete();
  }

  public closeModal(): void {
    this.store.dispatch(setSomethingWentWrongModalAppComponent({ isOpen: false }));
  }

  @HostListener('document:click', ['$event'])
  public documentClick(ev: MouseEvent): void {
    if (ev.target) {
      this.clickedElementService.documentClickedTarget.next(ev.target);
    }
  }
}
